
import moment from "moment";
import { Options, Vue } from "vue-class-component";
import Toaster from "../helpers/Toaster";
import VoucherService from "../service/VoucherService.js";
import { useStore, ActionTypes } from "../store";

@Options({
    props: {
        PreviewReceipt: Object,
    },
    watch: {
        PreviewReceipt(obj) {
            this.openDialog();
            this.dialogTitle = obj.dialogTitle;
            this.productDialog = obj.status;
            this.previewHeading = obj.previewHeading;

            if (obj.receiptID != 0) {
                this.loadReceipt(obj.receiptID);
            }
        },
    },
    emits: ["updatePreviewStatus"],
})
export default class PreviewReceipt extends Vue {
    private toast;
    private store = useStore();
    private productDialog = false;
    private showOnly = "Both";
    private dialogTitle = "";
    private voucherService;
    private previewHeading = "";
    private items = {
        storeName: "",
        storeAddress: "",
        storeEmail: "",
        storePhone: "",
        storeLicense: "",
        voucherNo: "",
        type: "",
        description: "",
        voucherDate: "",
        selectedProfile: "",
        itemList: [
            {
                accountName: "",
                debitAmount: 0,
                creditAmount: 0,
            },
        ],
    };

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.toast = new Toaster();
        this.voucherService = new VoucherService();
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.productDialog = true;
    }

    closeDialog() {
        this.$emit("updatePreviewStatus", {});
        this.productDialog = false;
    }

    getCompanyURL() {
        return require("@/assets/images/logo.png").default;
    }

    loadReceipt(receiptID) {
        this.voucherService.getReceiptData(receiptID).then((res) => {
            if (res != null) {
                this.items.storeName = res.storeDetail.name;
                this.items.storeAddress = res.storeDetail.address;
                this.items.storeEmail = res.storeDetail.email;
                this.items.storePhone = res.storeDetail.contact;
                this.items.storeLicense = res.storeDetail.license_no;
                this.items.voucherNo = res.voucher.voucher_no;
                this.items.description = res.voucher.memo;
                this.items.voucherDate = res.voucher.voucher_date;
                this.items.type = res.voucher.type;
                this.items.selectedProfile = res.voucher.profile_name;

                let vList = res.voucherList;

                if (vList.length > 0) {
                    this.items.itemList = [];
                    vList.map((v) => {
                        if (
                            this.items.type == "JRV" ||
                            this.items.type == "OPB"
                        ) {
                            this.showOnly = "Both";

                            if (v.type == "Debit") {
                                this.items.itemList.push({
                                    accountName: v.account_name,
                                    debitAmount: Number(v.amount),
                                    creditAmount: 0,
                                });
                            } else {
                                this.items.itemList.push({
                                    accountName: v.account_name,
                                    debitAmount: 0,
                                    creditAmount: Number(v.amount),
                                });
                            }
                        } else if (this.items.type == "CRV") {
                            this.showOnly = "Credit";

                            if (v.type == "Credit") {
                                this.items.itemList.push({
                                    accountName: v.account_name,
                                    debitAmount: 0,
                                    creditAmount: Number(v.amount),
                                });
                            }
                        } else if (this.items.type == "DBV") {
                            this.showOnly = "Debit";

                            if (v.type == "Debit") {
                                this.items.itemList.push({
                                    accountName: v.account_name,
                                    debitAmount: Number(v.amount),
                                    creditAmount: 0,
                                });
                            }
                        } else if (this.items.type == "EXV") {
                            this.showOnly = "Debit";

                            if (v.type == "Debit") {
                                this.items.itemList.push({
                                    accountName: v.account_name,
                                    debitAmount: Number(v.amount),
                                    creditAmount: 0,
                                });
                            }
                        }
                    });

                    this.items.itemList.push({
                        accountName: "TOTAL",
                        debitAmount: Number(
                            this.fixDigits(this.totalDebitAmount)
                        ),
                        creditAmount: Number(
                            this.fixDigits(this.totalCreditAmount)
                        ),
                    });
                }
            }
        });
    }

    get totalDebitAmount() {
        let totalAmount = 0;
        this.items.itemList.forEach((v) => {
            totalAmount = totalAmount + Number(v.debitAmount);
        });
        return totalAmount;
    }

    get totalCreditAmount() {
        let totalAmount = 0;
        this.items.itemList.forEach((v) => {
            totalAmount = totalAmount + Number(v.creditAmount);
        });
        return totalAmount;
    }

    fixDigits(amt) {
        return Number(amt).toFixed(2);
    }

    formatDate(date) {
        return moment(date).format("DD-MM-YYYY");
    }

    printReceipt() {
        const printContents =
            document.getElementById("printableArea")?.innerHTML;

        if (printContents) {
            const newWindow = window.open("", "_blank"); // Open a new tab
            if (newWindow) {
                newWindow.document.write(window.document.head.innerHTML); // Write the head content
                newWindow.document.write(`
					<html>
						<head>
							<title>Other Expenses</title>
							<style>
								@media print {
									.dataTable-header {
										display: none;
									}
								}
							</style>
						</head>
						<body onload="window.print();">
							${printContents}
						</body>
					</html>
				`);
                newWindow.document.close(); // Close the document to finish writing
                newWindow.focus(); // Focus on the new tab
                newWindow.print(); // Trigger the print dialog
                setTimeout(() => {
                    newWindow.close(); // Close the new tab after printing
                }, 1000); // Adjust the timeout as needed
            } else {
                console.error("Failed to open a new tab.");
            }
        }
    }

    get currency() {
        return this.store.getters.getCurrency;
    }
}
